export interface MenuFiltersState {
    menuFilters: { [menuType: string]: FilterState };
}

export type FilterState = string[];

export default function () {
    return {};
}
